<script>
  export let enabled = false;
  export let iconUrl;
  export let type;
  export let unreadCount;
  export let title;
  export let menuItemClicked;
  export let mobile;
  const handleMenuItemClicked = function () {
    menuItemClicked(type);
  };
</script>

<style style="text/scss" lang="scss">
  @import '../vendor/design-system.scss';

  .tab {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 4px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    padding: 0 8px;
    color: #7f7f7f;
    cursor: pointer;
    &:first-child {
      padding-left: 0;
    }
    &:hover {
      color: #a893f9;
      opacity: 1;
    }
    .count {
      background: #ff5567;
      padding: 2px 8px;
      border-radius: 12px;
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      color: #ececec;
    }
  }
  // .disabled {
  //   cursor: not-allowed;
  //   .avatar {
  //     opacity: 50%;
  //   }
  //   .title {
  //     color: grey;
  //   }
  // }

  .item {
    padding-left: 24px;
    // padding-right: 24px;
    border-right: 24px solid transparent;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: left;

    cursor: pointer;
    background: url(/images/arrow-grey.svg) no-repeat right 50%;
    background-size: 8px;
    &:hover {
      background-color: #f9f7ff;
    }

    .avatar {
      width: 48px;
      height: 48px;
      display: block;
      border-radius: 50%;
      background-size: 16px, 100%;
    }
    .count {
      // min-width: 24px;
      // height: 24px;
      // padding: 0 2px;
      // background: #ff6d6d;
      // text-align: center;
      // color: #ffffff;
      // border: 2px solid #f9f7ff;
      // border-radius: 8px;
      position: absolute;
      right: 24px;
      font-weight: 700;
      font-size: 11px;
      // line-height: 20px;
    }

    .badge-red {
      background-color: $red-pink;
    }

    .title {
      width: calc(100% - 140px);
      margin: 0 16px;
    }
  }
</style>

{#if mobile}
  <div class="item {enabled ? 'enabled' : 'disabled'}" on:click|preventDefault|stopPropagation={handleMenuItemClicked}>
    <span class="avatar" style="background: url({iconUrl}) no-repeat 50%, #f5f3fc;" />
    <div class="title">{title}</div>
    {#if unreadCount && unreadCount > 0}
      <span class="count badge badge-red">{unreadCount > 99 ? '99+' : unreadCount}</span>
    {/if}
  </div>
{:else}
  <div class="tab {enabled ? 'enabled' : 'disabled'}" on:click|preventDefault|stopPropagation={handleMenuItemClicked}>
    {title}
    {#if unreadCount && unreadCount > 0}
      <span class="count">{unreadCount > 99 ? '99+' : unreadCount}</span>
    {/if}
  </div>
{/if}
